import { render, staticRenderFns } from "./MapPosition.vue?vue&type=template&id=20e24787"
import script from "./MapPosition.vue?vue&type=script&lang=js"
export * from "./MapPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports